import {RankedModeTypes} from '../../../../shared/GameEnums'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'

export class UILeaderboardSidebarTabsController {
    private readonly onChangeRankedModeType: (modeType: RankedModeTypes) => void
    private readonly tabElements: HTMLAnchorElement[] = []
    private enabledRankModeTypes: RankedModeTypes[]

    constructor(onChangeRankedModeType: (modeType: RankedModeTypes) => void) {
        this.onChangeRankedModeType = onChangeRankedModeType
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.Classic1v1]) as HTMLAnchorElement)
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.Classic4P]) as HTMLAnchorElement)
        this.tabElements.push(document.getElementById(RankedModeTypes[RankedModeTypes.CitiesAndKnights4P]) as HTMLAnchorElement)
        this.addSidebarEventHandlers()
    }

    private addSidebarEventHandlers() {
        for(const sidebarButton of this.tabElements) {
            setElementOnClick(sidebarButton, () => {
                const rankedModeType = RankedModeTypes[sidebarButton.id]
                if(this.enabledRankModeTypes.indexOf(rankedModeType) === -1) return
                this.onChangeRankedModeType(rankedModeType)
                if(!UIUtilsEjsVariables.isUserOnMobileApp) return
                const inputBtn = sidebarButton.children[0] as HTMLInputElement
                inputBtn.checked = true
            }, true)
        }
    }

    highlightTab(tab: RankedModeTypes) {
        for(const sidebarButton of this.tabElements) {
            const rankedModeType = RankedModeTypes[sidebarButton.id]
            if(rankedModeType === tab) {
                sidebarButton.classList.add('active')
            } else {
                sidebarButton.classList.remove('active')
            }
        }
    }

    setEnabledRankedModeTypes(rankedModeTypes: RankedModeTypes[]) {
        this.enabledRankModeTypes = rankedModeTypes
        for(const sidebarButton of this.tabElements) {
            const rankedModeType = RankedModeTypes[sidebarButton.id]
            if(rankedModeTypes.indexOf(rankedModeType) === -1) {
                sidebarButton.classList.add('disabled')
            } else {
                sidebarButton.classList.remove('disabled')
            }
        }
    }
}
